import React from 'react';
import get from 'lodash/get';
import classnames from 'classnames';
import styles from './InputLabel.module.scss';
import { getLabelId } from 'utils';

type Props = {
  text: React.ReactChild,
  className?: string,
};

class InputLabel extends React.PureComponent<Required<Props>> {
  static defaultProps: OptionalProps<Props> = {
    className: undefined,
  };

  labelFor: string = getLabelId();

  render() {
    const { text, className } = this.props;

    return (
      <>
        <label
          className={ classnames(styles.label, className) }
          htmlFor={ this.labelFor }
        >
          { text }
        </label>
        { this.renderChildren() }
      </>
    );
  }
  // change id of first input in label children
  // to use `htmlFor` correctly
  private renderChildren() {
    return React.Children.map(this.props.children, (child, index) => {
      if (index !== 0) return child;
      if (typeof child === 'string') return child;

      return React.cloneElement(child as any, {
        attrs: {
          id: this.labelFor,
          ...get(child, 'props.attrs', {}),
        },
      });
    });
  }
}

export default InputLabel;
